import React, { Component } from "react";
import { connect } from "react-redux";
import { getReceipt } from "../../../Core/Receipt/action";
import { getData } from "../../../Core/Projects/action";
import { postCoupon } from "../../../Core/Coupon/action";
import { sendFactor } from "../../../Core/SendFactor/action";
import baseUrl from "../../../Core/url";
import styles from "../../../Assets/Styles/Components/Book/Receipt/Receipt.module.css";
import Loader from "../../Loader";
import Modal from "./Modal";
import styles2 from "../../../Assets/Styles/Components/Book/Shoots/Shoots.module.css";

class Receipt extends Component {
	constructor() {
		super();
		this.state = {
			code: "",
			isCode: false,
			finalCost: 0,
			halfFinalCost: 0,
			currentBalance: "",
			isUsedBalance: false,
			isUsedBalanceHalf: false,
			creditUsage: 0,
			modalShow: false,
			payHalf: false,
			currentBalanceHalf: "",
			creditUsageHalf: 0,
			showHalfPaymentWarning: false
		};
	}

	componentDidMount() {
		// document.querySelector(`.${styles.receipt}`).scrollIntoView({ behavior: "smooth", });
		if (!this.props.project.slug) {
			if (window.location.search && window.location.search.substr(1)) {
				this.props.getData(Object.fromEntries(new URLSearchParams(window.location.search.substring(1))).slug, {});
				this.props.getReceipt(Object.fromEntries(new URLSearchParams(window.location.search.substring(1))).slug);
			}
		} else {
			this.props.getReceipt(this.props.project.slug);
		}
	}

	componentDidUpdate(preProps, preState) {
		if (preProps.data?.receipt !== this.props.data.receipt && !this.props.data.loading) {
			this.setValues();
		}
		if (this.props.data?.receipt?.final_cost && !this.state.isUsedBalance && (this.state.finalCost === 0 || preState.finalCost !== this.props.data.receipt.final_cost)) {
			this.setFinalCost(this.props.data.receipt.final_cost);
			this.setHalfFinalCost(this.props.data.receipt.final_cost/2);
		}
		if (this.props.data?.receipt?.current_balance && !this.state.isUsedBalance && (this.state.currentBalance === "" || preState.currentBalance !== this.props.data.receipt.current_balance)) {
			this.setCurrentBalance(this.props.data.receipt.current_balance);
			this.setCurrentBalanceHalf(this.props.data.receipt.current_balance);
		}
		console.log("Inside componentDidUpdate ***");
		if (this.state.finalCost < 7000000 && this.state.payHalf) {
			this.setState({
				payHalf: false,
				showHalfPaymentWarning: true
			});
		}
	}

	setValues = () => {
		const { couponCode, offPrice } = this.props.data.receipt;
		this.setState({ code: couponCode, isCode: true });
	}

	setFinalCost = (finalCost) => {
		this.setState({ finalCost });
		console.log("setting final cost value:", finalCost);
	}

	setHalfFinalCost = (halfFinalCost) => {
		this.setState({ halfFinalCost });
		console.log("setting half final cost value:", halfFinalCost);
	}

	setCurrentBalance = (currentBalance) => {
		this.setState({ currentBalance });
		console.log("setting currentBalance value:", currentBalance);
	}

	setCurrentBalanceHalf = (currentBalanceHalf) => {
		this.setState({ currentBalanceHalf });
		console.log("setting currentBalanceHalf value:", currentBalanceHalf);
	}

	handleCodeChange = (e) => {
		this.setState({ code: e.target.value.toLowerCase() });
	}

	sendReceipt = () => {
		// TODO: send receipt redux
		const { slug } = this.props.project;
		this.props.sendFactor(slug);
	}

	// sendCoupon = () => {
	// 	// TODO: send receipt redux
	// 	const { slug } = this.props.project;
	// 	const { code } = this.state;
	// 	// reset important values here:
	// 	code !== "" && this.props.postCoupon(slug, code);
	// 	// this.props.getReceipt(this.props.project.slug);
	// }

	// sendCoupon = () => {
	// 	// TODO: send receipt redux
	// 	const { slug } = this.props.project;
	// 	const { code } = this.state;
	// 	const { receipt } = this.props.data;

	// 	// Ensure receipt data exists before setting values
	// 	if (receipt) {
	// 		this.setState({
	// 			finalCost: receipt.final_cost,
	// 			halfFinalCost: receipt.final_cost / 2,
	// 			currentBalance: receipt.current_balance,
	// 			currentBalanceHalf: receipt.current_balance,
	// 			creditUsage: 0, // Resetting to 0 as it's calculated again later
	// 			creditUsageHalf: 0,
	// 		}, () => {
	// 			// Ensure state is updated before proceeding
	// 			if (code !== "") {
	// 				this.props.postCoupon(slug, code);
	// 			}
	// 		});
	// 	}
	// }

	sendCoupon = async () => {
		const { slug } = this.props.project;
		const { code } = this.state;
		const { receipt } = this.props.data;

		if (code !== "") {
			await this.props.postCoupon(slug, code); // Wait for postCoupon to complete

			// Ensure receipt data exists before updating state
			if (receipt) {
				this.setState({
					finalCost: receipt.final_cost,
					halfFinalCost: receipt.final_cost / 2,
					currentBalance: receipt.current_balance,
					currentBalanceHalf: receipt.current_balance,
					creditUsage: 0,
					creditUsageHalf: 0,
					isUsedBalance: false,
					isUsedBalanceHalf: false
				});
			}
		}
	};

	useBalance = () => {
		// TODO: return data to redux
		const { currentBalance, finalCost } = this.state;
		const cb = Number(currentBalance);
		const fc = Number(finalCost);
		if (cb > fc) {
			const res = cb - fc;
			this.setState({ isUsedBalance: true });
			this.animateValueFinal(fc, 0, "finalCost");
			this.animateValueBalance(cb, res, "currentBalance");
			this.animateCreditUsage(0, fc, "creditUsage");
		}
		if (cb === fc) {
			this.setState({ isUsedBalance: true, });
			this.animateValueFinal(fc, 0, "finalCost");
			this.animateValueBalance(cb, 0, "currentBalance");
			this.animateCreditUsage(0, fc, "creditUsage");
		}
		if (cb < fc) {
			const res = fc - cb;
			this.setState({ isUsedBalance: true });
			this.animateValueFinal(fc, res, "finalCost");
			this.animateValueBalance(cb, 0, "currentBalance");
			this.animateCreditUsage(0, cb, "creditUsage");
		}
	}

	useBalanceHalf = () => {
		// TODO: return data to redux
		const { currentBalanceHalf, halfFinalCost } = this.state;
		const cb = Number(currentBalanceHalf);
		const fc = Number(halfFinalCost);
		if (cb > fc) {
			const res = cb - fc;
			this.setState({ isUsedBalanceHalf: true });
			this.animateValueFinal(fc, 0, "halfFinalCost");
			this.animateValueBalance(cb, res, "currentBalanceHalf");
			this.animateCreditUsage(0, fc, "creditUsageHalf");
		}
		if (cb === fc) {
			this.setState({ isUsedBalanceHalf: true, });
			this.animateValueFinal(fc, 0, "halfFinalCost");
			this.animateValueBalance(cb, 0, "currentBalanceHalf");
			this.animateCreditUsage(0, fc, "creditUsageHalf");
		}
		if (cb < fc) {
			const res = fc - cb;
			this.setState({ isUsedBalanceHalf: true });
			this.animateValueFinal(fc, res, "halfFinalCost");
			this.animateValueBalance(cb, 0, "currentBalanceHalf");
			this.animateCreditUsage(0, cb, "creditUsageHalf");
		}
	}

	animateValueFinal = (start, end, dynamicmodel) => {
		if (start === end) return;
		const range = start - end;
		let current = start;
		const stepTime = Math.abs(Math.floor(1000000 / range));
		setTimeout(() => {
			const timer = setInterval(() => {
				current += -100000;
				if (current < 0) {
					current = end;
				}
				if (current >= end) {
					this.setState({ [dynamicmodel]: current });
					console.log("dynamicmodel : ", dynamicmodel, [dynamicmodel]);
					if (current === end) {
						clearInterval(timer);
					}
				}
			}, stepTime);
		}, 1);
	}

	animateValueBalance = (start, end, dynamicmodel) => {
		if (start === end) return;
		const range = start - end;
		let current = start;
		const stepTime = Math.abs(Math.floor(1000000 / range));
		// console.log("stepTime : ", stepTime);
		setTimeout(() => {
			const timer = setInterval(() => {
				current += -100000;
				if (current < 0) {
					current = end;
				}
				if (current >= end) {
					this.setState({ [dynamicmodel]: current });
					// console.log("current : ", current);
					if (current === end) {
						clearInterval(timer);
					}
				}
			}, stepTime);
		}, 1);
	}

	animateCreditUsage = (start, end, dynamicmodel) => {
		if (start === end) return;
		const range = start - end;
		let current = start;
		const stepTime = Math.abs(Math.floor(1000000 / range));
		setTimeout(() => {
			const timer = setInterval(() => {
				current += 100000;
				if (current > end) {
					current = end;
				}
				if (current <= end) {
					this.setState({ [dynamicmodel]: current });
					// console.log("current : ", current);
					if (current === end) {
						clearInterval(timer);
					}
				}
			}, stepTime);
		}, 1);
	}

	// payHalfPrice = (value) => () => {
	// 	this.setState({ payHalf: value }, () => {
	// 			console.log("payHalf:", this.state.payHalf);
	// 			console.log("finalCost:", this.state.finalCost);
	// 			console.log("halfFinalCost:", this.state.halfFinalCost);
	// 		}
	// 	);
	// };

	payHalfPrice = (value) => () => {
		if (value && this.state.finalCost < 7000000) {
			this.setState({ showHalfPaymentWarning: true, payHalf: false });
			return;
		}
		this.setState({ payHalf: value, showHalfPaymentWarning: false });
	};

	goGate = (e) => {
		const { currentBalance, finalCost, isUsedBalance, creditUsage } = this.state;
		const { slug } = this.props.project;
		const { phone, address, date, package_name, photographer, } = this.props.data.receipt;
		const values = {
			amount: finalCost,
			afterwards_url: `/app/projects/${slug}/success_payment_notification?${isUsedBalance ? "credit=true&" : ""}`,
			type: "reserve-payment",
			credit_usage: creditUsage,
			model_id: slug,
			mobile_number: phone,
			description: `${phone} | ${address} | ${date} | ${photographer}`
		};
		e.preventDefault();
		const data = new FormData(document.querySelector(`#receiptForm`));
		data.set("amount", finalCost);
		data.set("afterwards_url", `/app/projects/${slug}/success_payment_notification?${isUsedBalance ? "credit=true&" : ""}`);
		data.set("credit_usage", creditUsage);
		data.set("model_id", slug);
		data.set("mobile_number", phone);
		data.set("description", `${phone} | ${address} | ${date} | ${photographer}`);

		fetch("https://www.kadro.co/app/transactions/initial_send", {
			method: "POST",
			body: values,
		});

		// fetch(`https://www.kadro.co/app/transactions/initial_send`, {
		// 	method: "POST",
		// 	headers: { "Content-Type": "application/json" },
		// 	body: JSON.stringify({
		// 		transaction: values
		// 	})
		// });
	}

	render() {
		const { clientName, phone, address, date, shoot_type_name, package_name, photographer, package_cost, vat_cost, transportation_cost, tax, current_balance, final_cost, couponCode, offPrice } = this.props.data.receipt;
		const { code, isCode, finalCost, currentBalance, creditUsage, modalShow, creditUsageHalf, currentBalanceHalf, payHalf, halfFinalCost } = this.state;
		const { coupon, factor } = this.props;
		return (
			<>
				<div className={`container ${styles.receipt}`}>
					<div className="row">
						<div className="col-12">
							<div className={`custom-box ${styles.recBox} `}>
								<div className="row align-items-top justify-content-center">
									<div className={`col-12 col-md-6 ${styles.summary} align-self-stretch`}>
										<div className="row ">
											<div className="col-12 ">
												<div className={styles.dataRec}><div className={styles.icon}><i className="fas fa-user" /></div>{clientName}</div>
												<div className={styles.dataRec}><div className={styles.icon}><i className="fas fa-phone" /></div>{phone}</div>
												<div className={styles.dataRec}><div className={styles.icon}><i className="fas fa-map-marker-alt" /></div> آدرس: {address}</div>
												<div className={styles.dataRec}><div className={styles.icon}><i className="fas fa-calendar-check" /></div>تاریخ: {date}</div>
												<div className={styles.dataRec}><div className={styles.icon}><i className="fas fa-paperclip" /></div>رشته: {shoot_type_name}</div>
												<div className={styles.dataRec}><div className={styles.icon}><i className="fas fa-th-large" /></div>پکیج: {package_name}</div>
												<div className={styles.dataRec}><div className={styles.icon}><i className="fas fa-camera" /></div>متخصص: {photographer}</div>
											</div>
											<div className="col-12 ">
												<table>
													<tr>
														<td>پکیج:</td>
														<td>{package_cost ? new Intl.NumberFormat().format(package_cost) : 0} تومان</td>
													</tr>
													{offPrice &&
														<tr>
															<td>تخفیف پکیج:</td>
															<td>{offPrice ? new Intl.NumberFormat().format(offPrice) : 0} تومان</td>
														</tr>}
													<tr>
														<td>ایاب ذهاب:</td>
														{this.props.project.data.skip_location && <td>محاسبه بعد از ثبت مکان</td>}
														{!this.props.project.data.skip_location && <td>{transportation_cost ? new Intl.NumberFormat().format(transportation_cost) : 0} تومان</td>}
													</tr>
													<tr>
														<td>مالیت بر ارزش افزوده:</td>
														<td>{vat_cost ? new Intl.NumberFormat().format(vat_cost) : 0} تومان</td>
													</tr>
													<tr>
														<td>جمع کل:</td>
														<td>{package_cost ? new Intl.NumberFormat().format(Number(package_cost) + Number(transportation_cost) + Number(vat_cost) + Number(tax) - Number(offPrice)) : 0} تومان</td>
													</tr>
												</table>
											</div>
										</div>
										<div className="row p-3">
											{!isCode && <p className={styles.isCodeBox} onClick={() => { this.setState({ isCode: true }); }}>کد تخفیف داری؟</p>}
											{
												isCode &&
												<>
													<div className="col-7 p-0 ">
														<input
															type="text"
															name="offInput"
															value={code}
															onChange={this.handleCodeChange}
															placeholder="کوپن تخفیف"
														/>
													</div>
													<div className={`col - 5 ${styles.btnOff} `} onClick={this.sendCoupon}>اعمال کد</div>
												</>
											}
										</div>
										{
											coupon.coupon && coupon.coupon.error && <div className={`${styles.error} col - 12`}>{coupon.coupon.error}</div>
										}
										{
											coupon.coupon && coupon.coupon.response && <p className={`${styles.congratulation} col - 12`}>{coupon.coupon.message}</p>
										}
									</div>
									<div className="col-12 col-md-6">
										<div className={styles.btnSmsReceipt} onClick={this.sendReceipt} style={{ display: factor?.factor?.message ? "none" : "block" }}>
											{
												factor && factor.loading ? <Loader scale={0.5} /> : <p style={{ textAlign: "left" }}> دریافت پیش فاکتور با پیامک <i className="fas fa-mobile-alt" /></p>
											}
										</div>
										<div className={`${styles2.shoot}`}>
											<div className={`${styles2.selectionBar} row`}>
												<div className={`col-6 ${styles2.item} ${this.state.payHalf ? "" : styles2.selected}`} style={{ padding: "1em" }} onClick={this.payHalfPrice(false)}><i className="fas fa-gift mx-2"> </i>پرداخت کل مبلغ</div>
												<div className={`col-6 ${styles2.item} ${this.state.payHalf ? styles2.selected : ""}`} style={{ padding: "1em" }} onClick={this.payHalfPrice(true)}> ۵۰٪ پیش‌پرداخت </div>
											</div>
										</div>
										<div className="row">
											<div className="col-12 pb-4 mb-4">
												<p style={{ textAlign: "right" }}>
													{this.state.payHalf ? (
														<>
															۵۰٪ مبلغ سفارش را به عنوان پیش پرداخت واریز نمایید
															و الباقی را تا هنگام تحویل فایلها توسط متخصص تسویه نمایید.
														</>
													) : (
														<>
															هزینه سفارش تا ۷ روز بعد از تحویل آنلاین فایلها به متخصص پرداخت نمی شود تا شما اعلام رضایت کنید و مبلغ را برای متخصص آزاد کنید.
														</>
													)}
													{this.state.showHalfPaymentWarning &&
														<div className="alert alert-warning text-right my-3" style={{ color: "orange" }}>
															گزینه پیش پرداخت فقط برای سفارش‌های بالای ۷,۰۰۰,۰۰۰ تومان فعال است.
														</div>
													}
												</p>
											</div>
										</div>

										{
											!payHalf && currentBalance >= 0 &&
											<div className={`row ${styles.balanceBox} mb-5 `}>
												<div className="col-7 align-items-center justify-content-center pl-0 ">اعتبار: <b>{currentBalance ? new Intl.NumberFormat().format(Number(currentBalance)) : 0} تومان</b></div>
												<div className="col-5 ">
													<div className={styles.BtnBalance} onClick={this.useBalance}>استفاده از اعتبار</div>
												</div>
												{/* <div className={`${ styles.error } col - 12`}>اعتبار کافی نیست</div> */}
											</div>
										}
										{
											payHalf && currentBalanceHalf >= 0 &&
											<div className={`row ${styles.balanceBox} mb-5 `}>
												<div className="col-7 align-items-center justify-content-center pl-0 ">اعتبار: <b>{currentBalanceHalf ? new Intl.NumberFormat().format(Number(currentBalanceHalf)) : 0} تومان</b></div>
												<div className="col-5 ">
														<div className={styles.BtnBalance} onClick={this.useBalanceHalf}>استفاده از اعتبار</div>
												</div>
												{/* <div className={`${ styles.error } col - 12`}>اعتبار کافی نیست</div> */}
											</div>
										}
										{!payHalf && creditUsage !== 0 &&
											<div className={`row ${styles.balance} `}>
												<div className="col-6">اعتبار استفاده شده:</div>
												<div className="col-6 " style={{ textAlign: "left" }}>{new Intl.NumberFormat().format(Number(creditUsage))} تومان</div>
											</div>}
										{payHalf && creditUsageHalf !== 0 &&
											<div className={`row ${styles.balance} `}>
												<div className="col-6">اعتبار استفاده شده:</div>
												<div className="col-6 " style={{ textAlign: "left" }}>{new Intl.NumberFormat().format(Number(creditUsageHalf))} تومان</div>
											</div>}
										{!payHalf &&
											<div className={`row ${styles.finalPrice} `}>
												<div className="col-6">قابل پرداخت:</div>
												<div className="col-6 " style={{ textAlign: "left" }}>{new Intl.NumberFormat().format(Number(finalCost))} تومان</div>
											</div>
										}
										{payHalf &&
											<div className={`row ${styles.finalPrice} `}>
												<div className="col-6">قابل پرداخت:</div>
												<div className="col-6 " style={{ textAlign: "left" }}>{new Intl.NumberFormat().format(Number(halfFinalCost))} تومان</div>
											</div>
										}
										<form noValidate="" id="receiptForm" action="https://www.kadro.co/app/transactions/initial_send" acceptCharset="UTF-8" method="post">
											<input type="hidden" name="transaction[amount]" value={this.state.payHalf ? this.state.halfFinalCost : this.state.finalCost} />
											{ !payHalf &&
												<input type="hidden" name="transaction[afterwards_url]" value={`/app/projects/${this.props.project.slug}/success_payment_notification?${this.state.isUsedBalance ? "credit=true&" : ""}`} />
											}
											{payHalf &&
												<input type="hidden" name="transaction[afterwards_url]" value={`/app/projects/${this.props.project.slug}/success_payment_notification?${this.state.isUsedBalanceHalf ? "credit=true&" : ""}`} />
											}
											<input type="hidden" name="transaction[type]" value="reserve-payment" />
											<input type="hidden" name="transaction[credit_usage]" value={this.state.payHalf ? this.state.creditUsageHalf : this.state.creditUsage} />
											<input type="hidden" name="transaction[model_id]" value={this.props.project.slug} />
											<input type="hidden" name="transaction[half_payment]" value={this.state.payHalf} />
											<input type="hidden" name="transaction[mobile_number]" value={`${phone}`} />
											<input type="hidden" name="transaction[description]" value={`${phone} | ${address} | ${date} | ${photographer}`} />
											<button id="online-payment" className={styles.btnSelect} type="submit">ثبت و پرداخت</button>
											{/* <a id="offline-payment" className={styles.btnDisable}>پرداخت در محل (به زودی ...)</a> */}
										</form>
									</div>
								</div>
							</div>
							{/* <div className="col-12">
								<div className="row align-items-center justify-content-center">
									<div className="col-12 col-md-9">
										<div className={styles.exInfo}>
											<p> ۷ روز ضمانت بازگشت مبلغ</p>
											هزینه سفارش تا ۷ روز بعد از تحویل آنلاین فایلها به متخصص پرداخت نمی شود تا شما اعلام رضایت کنید و مبلغ را برای متخصص آزاد کنید.
										</div>
									</div>
								</div>
							</div> */}
						</div>
					</div>
				</div>
				<Modal modalShow={modalShow} onCloseModal={() => { this.setState({ modalShow: false }); }} />
			</>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		data: state.receipt,
		project: state.project,
		coupon: state.coupon,
		factor: state.factor,
	};
};
export default connect(mapStateToProps, { getReceipt, getData, postCoupon, sendFactor })(Receipt);
